import {FeedbackType, SurveyQuestionInterface, SurveyResultInterface} from "../SurveyResult/interfaces";

export enum VisionStatementStatus {
  None,
  Saved,
  Created
}

export interface VsSurveyRequest {
  id: string;
  created: string;
  deadline: string;
  status: string;
  completed: string;
  questions: Array<SurveyQuestionInterface>;
  surveyResult: SurveyResultInterface;
  ownSurvey?: boolean;
  surveyMultipleRecipientId?: string;
}

export interface StrArr {
  [index: string]: string[];
}


export interface VisionStatementInterface {
  id: string;
  surveyId: string | null;
  attention?: "ok"|"attention"|"behind"|"done";
  title: string;
  description: string;
  deadline: string;
  activated: string;
  updated: string;
  timeProgress: number;
  progress: number;
  development: number;
  effort: number;
  onTrack: number;
  avgGap: number;
  status: VisionStatementStatus;
  questions: Array<SurveyQuestionInterface>;
  surveyRequests: Array<VsSurveyRequest>;
  customerCategoryId: string;
  goals: number;
  activities: number;
  behaviors: number;
  subItemsDue:number
  feedbackType?: FeedbackType;
  barriersDone: boolean;
  snapshotDone: boolean;
  ownSurvey: boolean;
  translations_answers: StrArr;
}

export interface AwarenessInterface {
  important: number;
  well: number;
  energy: number;
  score: number;
  created: string;
}

export interface BarrierInterface {
  text: string;
  custom: boolean;
  used: boolean;
}

export enum VisionStatementPartStatus {
  None,
  Done,
}

export interface VisionStatementGoal {
  id: string;
  title: string;
  description: string;
  deadline: string;
  created: string;
  development: number;
  engagement: number;
  status: VisionStatementPartStatus;
  actions: Array<VisionStatementAction>;
}

export interface VisionStatementActivity {
  id: string;
  title: string;
  description: string;
  fromChat: boolean;
  deadline: string;
  created: string;
  status: VisionStatementPartStatus;
}

export interface VisionStatementAction {
  id: string;
  goal_id: string;
  title: string;
  description: string;
  deadline: string;
  created: string;
  status: VisionStatementPartStatus;
}

export interface VisionStatementBehavior {
  id: string;
  title: string;
  ifWhen: string;
  ifThen: string;
  barrier?: string;
  howOften: number;
  deadline: string;
  created: string;
  status: VisionStatementPartStatus;
}

export interface EditPart {
  id: string;
  goalId?: string;
  barrier?: string;
  ifWhen?: string;
  ifThen?: string;
  howOften?: number;
  type: string;
  title: string;
  description: string;
  deadline: string;
  barriers?: Array<BarrierInterface>;
}